import { createFileRoute } from '@tanstack/react-router'
import { getJwt } from '~/utils/utils'

export const Route = createFileRoute('/session-expired')({
	component: SessionExpired,
})

function SessionExpired() {
	const jwt = getJwt()

	return (
		<div className="bg-navy-100 h-screen overflow-x-hidden overflow-y-auto">
			<div className="children:flex-shrink-0 flex min-h-min flex-col items-center justify-center p-[24px] leading-none md:h-full">
				<div className="flex flex-col flex-wrap items-center justify-center gap-[20px] md:flex-row">
					<img
						alt="University of Melbourne"
						src="/logos/uom_logo.svg"
						className="h-[90px]"
					/>
					<img
						alt="Aila"
						src="/logos/aila_logo.svg"
						className="h-[56px]"
					/>
				</div>
				<div className="font-display pt-[32px] text-center text-[64px] text-white md:pt-[48px]">Your session has expired</div>
				<div className="font text-light-grey-50 max-w-[1080px] pt-[48px] text-center text-[38px] leading-[54px] font-light">
					The AI Learning Assistant is only accessible through the University of Melbourne's Learning Management System (LMS). Please open a new session in the LMS.
				</div>
				<div className="mt-[24px] flex gap-x-[12px]">
					<a
						href={`${jwt.payload.canvasBaseUrl}/courses/${jwt.payload.canvasCourseId}`}
						className="bg-light-blue-100 text-navy-100 hover:bg-light-blue-25 active:bg-light-blue-75 mt-[32px] px-[18px] py-[12px] text-[24px] font-medium"
					>
						LMS
					</a>
					<a
						href={`${jwt.payload.canvasBaseUrl}/courses/${jwt.payload.canvasCourseId}/external_tools/${jwt.payload.canvasExternalToolId}?display=borderless`}
						className="bg-light-blue-100 text-navy-100 hover:bg-light-blue-25 active:bg-light-blue-75 mt-[32px] px-[18px] py-[12px] text-[24px] font-medium"
					>
						Reload
					</a>
				</div>
			</div>
		</div>
	)
}
